import React from 'react';
import { ToggleButton, ToggleButtonGroup, Box, Chip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { BillingPeriod } from '../utils/paymentTiers';

interface BillingPeriodToggleProps {
  value: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
  savingsPercentage?: number;
  ariaLabel?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const DEFAULT_WRAPPER_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  justifyContent: 'center',
  mb: 3,
};

export const BillingPeriodToggle: React.FC<BillingPeriodToggleProps> = ({
  value,
  onChange,
  savingsPercentage,
  ariaLabel = 'billing period',
  disabled = false,
  sx,
}) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue) {
      onChange(newValue as BillingPeriod);
    }
  };

  const wrapperSx: SxProps<Theme> = sx
    ? ([DEFAULT_WRAPPER_SX, sx] as SxProps<Theme>)
    : DEFAULT_WRAPPER_SX;

  return (
    <Box sx={wrapperSx}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        aria-label={ariaLabel}
        size="small"
        disabled={disabled}
      >
        <ToggleButton value="monthly">Monthly</ToggleButton>
        <ToggleButton value="yearly">
          Yearly
          {savingsPercentage != null && savingsPercentage > 0 && (
            <Chip
              label={`Save ${savingsPercentage}%`}
              color="success"
              size="small"
              sx={{ ml: 1 }}
            />
          )}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
